import { put, takeEvery } from 'redux-saga/effects';

import { actions } from 'src/actions';

function* refetchUsersAfterForceLogout() {
  yield put(
    actions.api.users.getUsers.started({
      page: 1,
      limit: 50,
    })
  );
}

export function* usersSaga(): Generator {
  yield takeEvery(
    [actions.api.users.forceLogout.done],
    refetchUsersAfterForceLogout
  );
}
